import React from "react";
import { APP_VERSION } from "./version";

export const TitleScreen = ({
  saveExists,
  forceLandscape,
  crashMsg,
  onNewGame,
  onContinue,
  onScores,
  onSettings,
  onRotate,
  onDedication,
  onAdmin,
}) => (
  <div className="title-menu" data-testid="title-overlay">
    {crashMsg && (
      <div className="crash-note" data-testid="crash-note">
        {crashMsg}
      </div>
    )}
    <div className="title-buttons">
      <button className="rbtn primary" data-testid="title-new-game-btn" onClick={onNewGame}>
        משחק חדש
      </button>
      {saveExists && (
        <button className="rbtn" data-testid="title-continue-btn" onClick={onContinue}>
          המשך משחק שמור
        </button>
      )}
      <button className="rbtn" data-testid="title-scores-btn" onClick={onScores}>
        טבלת שיאים
      </button>
      <button className="rbtn" data-testid="title-settings-btn" onClick={onSettings}>
        הגדרות
      </button>
      <button className="rbtn small" data-testid="rotate-btn-title" onClick={onRotate}>
        {forceLandscape ? "⤢ חזרה למסך אורך" : "⤢ מסך רוחב"}
      </button>
    </div>
    <button className="ded-link" data-testid="title-dedication-btn" onClick={onDedication}>
      מקדש זיכרון למשחק אהוב
    </button>
    <div className="title-credit">
      גרסת מובייל למשחק הקלאסי · 1991
      <span className="title-version" data-testid="title-version">v{APP_VERSION}</span>
      <button className="admin-link" data-testid="admin-link-btn" onClick={onAdmin} title="ניהול">
        ⚙ ניהול
      </button>
    </div>
  </div>
);
